export const SUPPORT_EMAIL ="vc.support@varroc.com";
export const IOS_APP_LINK ="https://apps.apple.com/in/app/cariq-driven/id1194939452";
export const ANDROID_APP_LINK ="https://play.google.com/store/apps/details?id=com.cariq.mobility.cariqdriven&hl=en_IN";